import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { P500UIButtonsModule, P500UIIconsModule } from '@platform500services/p500-ui-kit';
import { NgClass, NgForOf, NgStyle } from '@angular/common';
import { IBanner } from './banners';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'gtd-banner',
  templateUrl: './banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [P500UIButtonsModule, P500UIIconsModule, NgStyle, NgForOf, NgClass, RouterLink],
})
export class BannerComponent {
  @Input() public banner: IBanner;
  @Input() public customClass: string;
  @Output() public onClose = new EventEmitter();
}
